/*
  Gallery arrows and counter for the "thumbnails beside the image" layout (feature 011,
  specs/011-product-page-redesign/contracts/pdp-ui.md §3). Uses Dawn's media-gallery to change the
  active media; on phones Dawn's own slider buttons and counter stay in charge.
*/
(() => {
  const init = (gallery) => {
    const controls = gallery.querySelector('[data-gallery-controls]');
    if (!controls || controls.dataset.ready) return;
    controls.dataset.ready = 'true';
    const items = () => [...gallery.querySelectorAll('.product__media-list > .product__media-item')];
    const current = gallery.querySelector('[data-gallery-current]');
    const index = () => Math.max(0, items().findIndex((item) => item.classList.contains('is-active')));
    const sync = () => { if (current) current.textContent = String(index() + 1); };
    const go = (step) => {
      const list = items();
      if (!list.length || typeof gallery.setActiveMedia !== 'function') return;
      const next = list[(index() + step + list.length) % list.length];
      gallery.setActiveMedia(next.dataset.mediaId, false);
      sync();
    };
    controls.querySelector('[data-gallery-prev]').addEventListener('click', () => go(-1));
    controls.querySelector('[data-gallery-next]').addEventListener('click', () => go(1));
    new MutationObserver(sync).observe(gallery.querySelector('.product__media-list'), { subtree: true, attributes: true, attributeFilter: ['class'] });
    controls.hidden = false;
    sync();
  };
  const run = () => document.querySelectorAll('media-gallery.product-gallery--side').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
